import AbstractMethodError from '../../error/AbstractMethodError.js';
import Construct from '../../event/Construct.js';
import MissingContainerError from '../../error/MissingContainerError.js';
import RecursionLimitError from '../../error/RecursionLimitError.js';
import ELModel from '../ELModel.js';
import { makeStruct } from '../../enums/MODELS.js';
// Model Structure
export const factoryModel = makeStruct([
    ['attributes', () => ({})],
    ['data', () => ({})]
]);
// Simplified Model
export function factory() {
    return {
        attributes: factoryModel().attributes,
        data: factoryModel().data
    };
}
/** An Abstract HTML Element Node Class Constructor Factory
    @description Performs Object and Element construction for nested Objects by allowing for the
    injection of Object/Element constructors and an array of Object MODEL(s).
    The FACTORY can be extended and overriden in such a way that you could import various FACTORIES
    into the parent Class without the need to directly import the underlying Classes for each Object

    This allows for greater scaleability and simplifies object management
*/
export default class FACTORY extends ELModel {
    constructors = {}; // Collection of Object/Element Constructor methods
    /** Constructs a factory for generating child Objects */
    constructor(model) {
        super(model);
        /** A Collection of Object/Element Constructor methods
            ie: this.constructors[foo]
            @type {{[key: string]: Function}}
        */
        this.constructors = {};
    }
    /** Add a constructor style function to this classes constructor collection
        @param className The Class/Object name that this callback is meant to construct
        @param fn Callback Function
    */
    addConstructor(className, fn) {
        if (typeof this.constructors[className] === 'undefined') {
            this.constructors[className] = fn;
        }
        else {
            console.warn('Constructor already exists for ' + className);
        }
    }
    /** Perform any async actions required to build the Element */
    build(model) {
        if (model) {
            if (model.children) {
                this.populate(model.children);
            }
        }
        return Promise.resolve();
    }
    /** Attempts to call the constructor of the given MODEL
        @see https://stackoverflow.com/a/35769291/722785
        @returns Promise to return a Constructed Element
    */
    create(model) {
        try {
            let result = this.constructors[model.className](model);
            return Promise.resolve(result);
        }
        catch (e) {
            console.warn(this.toString() + '.create(): No constructor exists for className "' + model.className + '"', this, model, e);
            return Promise.reject(e);
        }
    }
    /** Creates given MODEL(s) as children of this Factory
        @param children Array of MODEL(s) for EL construction
        @returns Promise to return an array of constructed Elements/Objects
    */
    populate(children) {
        return Promise.all(children.map((c) => this.create(c)));
    }
}
export { AbstractMethodError, Construct, MissingContainerError, RecursionLimitError };
